module.exports = __webpack_public_path__ + "media/images/covers/StarWorks-NEW-Intro-Video-Thumbnail-efb3da2ea0a18bd585f1e16d5513e065.jpg";